<div class="admin-children" [ngClass]="{ active: isActive }">
  <p [routerLink]="link" [ngClass]="{ active: isActive }" class="display-text">
    {{ displayText }}
  </p>
  @if (isActive) {
    <ion-icon [src]="IMAGES.DONE" alt="done" class="check"></ion-icon>
  }
</div>
